export const CookiesName = {
  token: 'accessToken',
  tokenExpiresAt: 'tokenExpiresAt',
  refreshToken: 'refreshToken',
  refreshTokenExpiresAt: 'refreshTokenExpiresAt',
  adminData: 'admin',
} as const;

export { getLeagueOfPredictorsAPIGateway } from '@/api/generated';
export * from '@/api/client';
